module.exports = __webpack_public_path__ + "static/img/2.d41ff41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/add/2.png
// module id = Vk2l
// module chunks = 1